import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-down-left', 'IconChevronDownLeft', [["path",{"d":"M8 8v8h8","key":"svg-0"}]]);